import type React from "react";
import style from "./Section.module.css";

type SectionProps = {
  children: React.ReactNode;
  className?: string;
  title?: React.ReactNode;
};

export const Section = ({ children, className = "", title }: SectionProps) => {
  return (
    <section className={`${style.section} ${className}`}>
      {title && <h1>{title}</h1>}
      {children}
    </section>
  );
};
